

<template>
<div>

</div>
    </template>
    
    
    <script>

    export default {
      components: {

      },
      data() {
        return {

          LoadReferenceCable: false,
        }
      },
      created() {
        this.getReferenceCable();
        },
    methods: {
      async getReferenceCable() {
        try {
          const res = await fetch(this.$store.state.storeGlobal.StoreApi + '/api/preco_refs?' +
          'fk_nb_fibre.nb_fibre='+this.$store.state.storeCable.cable.nombre.nbFibre +
          '&fk_type_fibre='+this.$store.state.storeCable.cable.type.pkTypeFibre +
          '&fk_pays.nom='+this.$store.state.storeGlobal.StorePays +
          "&fk_euroclass="+this.$store.state.storeCable.cable.euroclass.pkEuroclass +
          '&fk_env_web.nom='+this.$store.state.storeGlobal.StoreEnvWeb +
          '&fk_env.nom='+this.$store.state.storeGlobal.StoreEnv +
          '&fk_structure='+ this.$store.state.storeCable.cable.structure.pkStructureId ,{
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      headers: {
      "Accept": "application/json",
      "Content-Type": "application/json; charset=utf-8",
      "Authorization": this.$store.state.storeGlobal.StoreJwtToken
    },
    }
          )
          
          var resultApi = (await res.json());
          var cable = resultApi[0];
          //recherche code ref structure
         
          this.chooseCableFibre(cable.pk_ref, cable.ref.id , cable.ref.reference , cable.ref.qte_cable)
          this.LoadReferenceCable = true;
        } catch (error) {
          this.answer = 'Error! Could not reach the API. ' + error
        }
      },
      chooseCableFibre(pkLogiqueRef , pkCable, referenceCable , qteCableDispo){

        this.obj = {
          'cable' : {
            'reference' : {
              pkLogiqueRef:pkLogiqueRef,
              pkCable: pkCable,
              referenceCable: referenceCable , 
              qteCableDispo : qteCableDispo ,
        }
      }};
      
      this.$store.commit('SET_CHOICE_CABLE', this.obj )

      }
    },
    
    
    }
    </script>